import { Component, computed, input } from '@angular/core';
import { SpinnerComponent } from '../spinner/spinner';

export type LoadingStateSize = 'sm' | 'md' | 'lg';

const sizes: Record<LoadingStateSize, string> = {
  sm: 'min-h-24',
  md: 'min-h-36',
  lg: 'min-h-48',
};

const defaultSize: LoadingStateSize = 'md';

@Component({
  selector: 'wma-loading-state',
  template: '<wma-spinner />',
  imports: [SpinnerComponent],
  host: {
    '[class]': 'hostClasses()',
  },
})
export class LoadingStateComponent {
  /** The minimum height of the loading state. */
  size = input<LoadingStateSize>();

  /* The CSS classname applied to the host element. */
  hostClasses = computed(() => {
    return `flex items-center justify-center ${sizes[this.size() || defaultSize]}`;
  });
}
